<div class="row">
  <div class="col-md-6">
    <button class="btn btn-light float-end" type="button" (click)="cancel()">Cancel</button>
  </div>
  <div class="col-md-6">
    <button class="btn btn-danger" type="button" (click)="accept()">Accept</button>
  </div>
</div>